import React from 'react'

import { CreateButton, ExportButton, TopToolbar } from 'ra-ui-materialui'
import { Box } from '@material-ui/core'

import { FilterButton } from '../FilterButton'
import { FilterProvider } from '../FilterContext'
import { FilterModal } from '../FilterModal'

import { Props } from './types'

const Wrapper: React.FC<Props> = ({ children }) => (
  <FilterProvider>{children}</FilterProvider>
)

export const Toolbar: React.FC<Props> = ({ children }) => {
  return (
    <Wrapper>
      <Box width="100%">
        <TopToolbar>
          <FilterButton />
          <CreateButton />
          <ExportButton />
        </TopToolbar>

        <FilterModal>{children}</FilterModal>
      </Box>
    </Wrapper>
  )
}
